import React from 'react'
import md5 from 'md5'
import { useGoogleMap } from '../GoogleMapProvider'

function GoogleMapView ({ geometry = null, marker: location = null }) {

  const {
    scriptLoaded,
  } = useGoogleMap()

  const mapDivRef = React.useRef(null)
  const [googleMap, setGoogleMap] = React.useState(null)
  const [marker, setMarker] = React.useState(null)
  const [geoHash, setGeoHash] = React.useState(null)
  const [data, setData] = React.useState(null)

  if (typeof window !== 'undefined') {
    React.useEffect(() => {
      if (!scriptLoaded) {
        setData(null)
        return;
      }
      let g = null
      let bounds = null
      if (geometry) {
        g = geometry.features[0].geometry
        if (g && g.type === 'MultiPolygon') {
          let minX = 180
          let maxX = -180
          let minY = 180
          let maxY = -180
          let polygons = []
          if (g.type === 'MultiPolygon') {
            polygons = g.coordinates[0]
          } else if (g.type === 'Polygon') {
            polygons = [g.coordinates[0]]
          }

          if (polygons.length) {
            for (let poly of polygons) {
              for (let [ y, x ] of poly) {
                if (x < minX) minX = x
                if (x > maxX) maxX = x
                if (y < minY) minY = y
                if (y > maxY) maxY = y
              }
            }
            bounds = [ { lat: minX, lng: minY }, { lat: maxX, lng: maxY } ]
          }
        }
      }
      setData({
        geoJson: geometry,
        bounds,
      })
    }, [geometry, scriptLoaded])

    // useWhatChanged([mapDivRef, googleMap, data, geoHash, location, marker, scriptLoaded]); // debugs the below useEffect

    React.useEffect(() => {
      if (!mapDivRef.current || !scriptLoaded || !data) return;
      const element = mapDivRef.current
      if (element === null) {
        console.error('Map div element is not initialized')
        return;
      }
      const { Map, Marker } = google.maps

      let map
      if (!googleMap) {
        map = new Map(element, {
          disableDefaultUI: true,
          draggable: false,
          gestureHandling: 'none',
          keyboardShortcuts: false,
          zoom: 15,
        })
        setGoogleMap(map)
      } else map = googleMap

      const { bounds, geoJson } = data

      const hash = md5(JSON.stringify(geoJson))

      if (hash && hash !== geoHash) {
        if (bounds) {
          map.fitBounds(new google.maps.LatLngBounds(...bounds), 0)
        }
        map.data.setStyle({
          fillColor: '#152231',
          strokeWeight: 1,
          strokeColor: '#152231',
        });

        map.data.forEach(function (feature) {
          map.data.remove(feature);
        });
        if (geoJson) {
          map.data.addGeoJson(geoJson)
        }
        setGeoHash(hash)
      }

      if (location) {
        const lat = Number(location.lat)
        const lng = Number(location.lng)
        let drawMarker = true
        if (marker) {
          if (marker.position) {
            const markerLat = marker.position.lat().toFixed(5)
            const markerLng = marker.position.lng().toFixed(5)
            if (markerLat === lat.toFixed(5) && markerLng === lng.toFixed(5)) {
              drawMarker = false
            }
          }
          if (drawMarker) {
            marker.setMap(null)
            map.setCenter(marker.position)
          }
        }

        if (drawMarker) {
          setMarker(new Marker({
            position: {
              lat,
              lng,
            },
            map,
          }))
        }
      }
    }, [mapDivRef, googleMap, data, geoHash, location, marker, scriptLoaded])
  }
  return (
    <div>
      <div style={{ width: '100%', height: '400px', marginBottom: '15px', cursor: 'default !important' }} ref={mapDivRef} id="map"/>
    </div>
  )

}

export default GoogleMapView
